import React, { FC } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

interface CardCarouselProps {
  cards: React.ReactNode[];
}

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 1, // slide one card at a time
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const CardCarousel: FC<CardCarouselProps> = ({ cards }) => {
  return (
    <Carousel
      responsive={responsive}
      arrows={true}
      swipeable={true}
      draggable={true}
      infinite={false}
      keyBoardControl={true}
      containerClass="carousel-container"
      removeArrowOnDeviceType={[]}
    >
      {cards.map((card, index) => (
        <div key={index}>{card}</div>
      ))}
    </Carousel>
  );
};

export default CardCarousel;
